import { LocaleEnum } from 'schema/locale';
import { Page, SanityReference } from 'types/studio/studio';

type SanityLinkType =
  | {
      external?: string;
      internal?: SanityReference<Page>;
    }
  | SanityReference<Page>
  | undefined;

const isSanityExternalLink = (link: SanityLinkType): link is { external?: string } => {
  return !!link && typeof link === 'object' && 'external' in link;
};

export const getSanityLinkUrl = (link: SanityLinkType, locale?: LocaleEnum) => {
  const parsedLocale = locale === LocaleEnum.enUS ? '' : locale || ''; // Omit en-us as default locale
  if (isSanityExternalLink(link) && link.external?.length) return link.external;
  if (
    link &&
    typeof link === 'object' &&
    'internal' in link &&
    link.internal?.slug?.current.length
  ) {
    return `/${parsedLocale}/${link.internal.slug.current}`.replace(/\/+/g, '/');
  }
  if (link && 'slug' in link && link.slug?.current.length) {
    return `/${parsedLocale}/${link.slug.current}`.replace(/\/+/g, '/');
  }
  return undefined;
};
